import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ErrorIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M13 18v-2.667h-2V18h2ZM13 13.333V6h-2v7.333h2Z M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm9-11a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </IconWrapper>
)

export default ErrorIconMedium
